/*jslint browser: true, devel:true */
/*global define, G_vmlCanvasManager*/

import $ from 'jquery';


    const activeBonus = $('.active-bonus');

    activeBonus.each(function () {
        let canvas = document.createElement('canvas');
        let span = document.createElement('span');
        let ctx;
        let radius;
        let drawCircle;

        let options = {
            percent: $(this).attr('data-percent'),
            size: $(this).attr('data-size') || 70,
            lineWidth: $(this).attr('data-line') || 2
        };

        span.textContent = `${options.percent}%`;

        if (window.G_vmlCanvasManager) {
            window.G_vmlCanvasManager.initElement(canvas);
        }

        ctx = canvas.getContext('2d');
        canvas.width = canvas.height = options.size;

        $(this).prepend(span);
        $(this).prepend(canvas);

        ctx.translate(options.size / 2, options.size / 2); // change center

        radius = (options.size - options.lineWidth) / 2;

        drawCircle = function (color, lineWidth, percent) {
            percent = Math.min(Math.max(0, percent || 1), 1);
            ctx.beginPath();
            ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
            ctx.strokeStyle = color;
            ctx.lineCap = 'round';
            ctx.lineWidth = lineWidth;
            ctx.stroke();
        };

        drawCircle('#525252', options.lineWidth, 1);
        drawCircle('#8eb50d', options.lineWidth, options.percent / 100);
    });





// WEBPACK FOOTER //
// ./mobile-core/src/bonus-progress.js